var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 0.666992H3.16671C2.43337 0.666992 1.83337 1.26699 1.83337 2.00033V11.3337H3.16671V2.00033H11.1667V0.666992ZM13.1667 3.33398H5.83333C5.1 3.33398 4.5 3.93398 4.5 4.66732V14.0007C4.5 14.734 5.1 15.334 5.83333 15.334H13.1667C13.9 15.334 14.5 14.734 14.5 14.0007V4.66732C14.5 3.93398 13.9 3.33398 13.1667 3.33398ZM13.1667 14.0003H5.83337V4.66699H13.1667V14.0003Z",
    fill: "#2565E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultCopyIcon);
export default __webpack_public_path__ + "static/media/vault-copy-icon.71c5f4bd5203cb252d39f47d4eeb90db.svg";
export { ForwardRef as ReactComponent };